import React from 'react';
import AddSmsSettingComponent from '../../../Components/SmsSetting/AddSmsSetting';

export default function AddSmsSetting() {
    return (
        <div className='page-body'>
            <AddSmsSettingComponent />
        </div>
    );
}